module.exports = __webpack_public_path__ + "static/media/qr-code-small.07d718cc.svg";